import type { IconData } from '@stacksjs/iconify-core'

export const selectCircleArea1: IconData = {
  "body": "<path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\" d=\"M27 3.213c1.67.239 3.278.675 4.798 1.283M21 3.213c-1.66.237-3.256.669-4.767 1.27M27 44.788a21 21 0 0 0 4.798-1.283M21 44.788a21 21 0 0 1-4.829-1.296M44.787 27a21 21 0 0 1-1.282 4.797M44.787 21a21 21 0 0 0-1.27-4.766M3.213 21c.24-1.682.68-3.3 1.294-4.828M3.213 27c.239 1.67.674 3.278 1.282 4.797M36.964 7.478A21 21 0 0 1 40.5 11.01M11.01 40.502a21 21 0 0 1-3.531-3.537m33.042 0a21 21 0 0 1-3.557 3.557M7.499 11.01a21 21 0 0 1 3.51-3.51\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default selectCircleArea1
